var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 28,
    viewBox: "0 0 57 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.804688,
    width: 56.0363,
    height: 27,
    rx: 4,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7374 8.80469H8.03703L8 9.02613C11.6566 9.90893 14.0762 12.0402 15.0804 14.6016L14.0583 9.70403C13.8821 9.0291 13.37 8.82802 12.7374 8.80469Z",
    fill: "#F9A51A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2028 9.25266C37.6256 9.03674 36.721 8.80469 35.5908 8.80469C32.7111 8.80469 30.6818 10.2504 30.6648 12.321C30.649 13.8533 32.113 14.7064 33.2189 15.2172C34.3529 15.7385 34.7348 16.072 34.7288 16.5382C34.7216 17.2526 33.8234 17.5788 32.9856 17.5788C31.8188 17.5788 31.1994 17.418 30.2421 17.0201L29.8662 16.8504L29.4571 19.2362C30.1386 19.5332 31.3965 19.7915 32.7038 19.8047C35.7679 19.8047 37.7571 18.3759 37.7793 16.164C37.7899 14.9516 37.0139 14.0289 35.3328 13.2692C34.3133 12.7758 33.6897 12.4462 33.6965 11.9473C33.6965 11.5053 34.2239 11.0306 35.3648 11.0306C36.3192 11.0157 37.0088 11.2232 37.5464 11.4395L37.8082 11.5617L38.2028 9.25266ZM24.7189 19.6465L26.5413 8.99052H29.4555L27.6323 19.6465H24.7189ZM43.4253 9.00094H45.6776L48.0363 19.6493H45.3315C45.3315 19.6493 45.0646 18.4258 44.9773 18.0529C44.7519 18.0529 43.8104 18.0517 42.9256 18.0506L42.9133 18.0506C42.1336 18.0496 41.4007 18.0487 41.2445 18.0487C41.1313 18.3367 40.6311 19.6493 40.6311 19.6493H37.57L41.8983 9.88459C42.2057 9.19014 42.7272 9.00094 43.4253 9.00094ZM42.0827 15.8691C42.324 15.2552 43.2444 12.8898 43.2444 12.8898C43.2359 12.9037 43.2925 12.757 43.3699 12.5567L43.37 12.5565C43.4511 12.3465 43.5551 12.0775 43.6305 11.8729L43.8271 12.7918C43.8271 12.7918 44.3856 15.335 44.5027 15.8691H42.0827ZM19.4212 16.2647L22.2741 8.99827H25.3612L20.7731 19.6334L17.689 19.6377L15.0804 10.3176C16.9305 11.2407 18.586 13.0852 19.1168 14.788L19.4212 16.2647Z",
    fill: "#1A1F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa01);
export default __webpack_public_path__ + "static/media/visa-01.1ac0abab9c5fdae49835f996ed3008e3.svg";
export { ForwardRef as ReactComponent };